import React from "react";
import "./Home.css";
import Product from "./Product";
function Home() {
  return (
    <div className="home">
      <div className="home__container">
        <img
          className="home__image"
          src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
          alt=""
        />

        <div className="home__row">
          <Product
            id="12321041"
            title="Mkeke for iPhone 14 Pro Max Case, [Military Grade Protection] [Durable & Shockproof] for iPhone 14 Pro MaxSlim Case [Black to Green Gradient]"
            price={11.96}
            rating={5}
            image="https://m.media-amazon.com/images/I/71RM0PMHRAL._AC_SX679_.jpg"
          />
          <Product
            id="49538084"
            title="Vizio D40F-G9 40-inch 1080p Full Array LED SmartCast HDTV (Renewed"
            price={199.99}
            rating={4}
            image="https://m.media-amazon.com/images/I/61kRDvk7alL._AC_SL1000_.jpg" alt =""
           />
          <Product
            id="49538084"
            title="Ethiopian and Eritrean Traditional Habeshan Dress |Ethiopian Traditional Dress|Eritrean Dress|Habesha Kemis|Zuria|Habesha Chiffon|Kemis"
            price={239.99}
            rating={5}
            image="https://i.etsystatic.com/31232159/r/il/eb6da7/4415497396/il_1588xN.4415497396_rg5n.jpg" alt =""
           />
        </div>
        <div className="home__row">
          <Product
            id="12321341"
            title="Dell UltraSharp U4919DW 49 inch Dual QHD Curved Monitor - 8ms Response Time, 2X HDMI, 1x DP, 5X USB Downstream, 2X USB Upstream 3.0, 1 x USB Type-C"
            price={11.96}
            rating={5}
            image="https://m.media-amazon.com/images/I/81ZXKUvoyuL._AC_SY400_.jpg"
          />
          <Product
            id="49538094"
            title="Amazfit GTS 4 Smart Watch for Men, Dual-Band GPS, Alexa Built"
            price={199.99}
            rating={4}
            image="https://m.media-amazon.com/images/I/61lmmx6h63L._AC_SY400_.jpg" alt =""
           />
        </div>
        <div className="home__row">
          <Product
            id="4903850"
            title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor"
            price={199.99}
            rating={3}
            image="https://images-na.ssl-images-amazon.com/images/G/01/AMAZON_FASHION/2023/SITE_FLIPS/SPR23/GW/APRIL/DQC/D1_DQC_April23_SpringF_WO_372x232._SY232_CB594716668_.jpg"
          />
          <Product
            id="23445930"
            title="Amazon Echo (3rd generation) | Smart speaker with Alexa, Charcoal Fabric"
            price={98.99}
            rating={5}
            image="https://media.very.co.uk/i/very/P6LTG_SQ1_0000000071_CHARCOAL_SLf?$300x400_retinamobilex2$"
          />
          <Product
            id="3254354345"
            title="
            Qifutan Cell Phone Holder for Car Phone Mount Long Arm Dashboard Windshield Car Phone Holder Strong Suction Anti-Shake Stabilizer Phone Car Holder.."
            price={15.99}
            rating={5}
            image="https://m.media-amazon.com/images/I/81sgKHRN7mL.__AC_SX300_SY300_QL70_FMwebp_.jpg"
          />
        </div>
        <div className="home__row">
          <Product
            id="90829332"
            title="Microsoft Surface Pro 7 – 12.3 Touch-Screen - Intel Core i3-4GB Memory - 128GB Solid State Drive – Platinum"
            price={1094.98}
            rating={4}
            image="	https://m.media-amazon.com/images/I/71kBlSKi3eL._AC_SX450_.jpg"
          />
          <Product
            id="90829332"
            title="
ASUS 27” 1080P Monitor (VA27DCP) - Full HD, IPS, 75Hz, USB-C 65W Power Delivery, Speakers, Adaptive-Sync/FreeSync, Eye Care, Low Blue Light, Flicker Free,..."
            price={1094.98}
            rating={4}
            image="	https://m.media-amazon.com/images/I/81RDCvXxqeL._AC_SL1500_.jpg"
          />
        </div>
      </div>
    </div>
  );
}

export default Home